import { render, staticRenderFns } from "./CloudServerIcon.vue?vue&type=template&id=4c978e33"
import script from "./CloudServerIcon.vue?vue&type=script&lang=js"
export * from "./CloudServerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports